import Application from "../../Application";
import FormVersionEvaluationsPresenter, {
  IFormVersionEvaluationsPresenter
} from "../../presenter/evaluation/FormVersionEvaluationsPresenter";
import { IEvaluationService } from "../../service/evaluation/EvaluationService";
import { INotificationService } from "../../service/notification/NotificationService";
import { TEvaluationPresentationModel } from "../../presenter/applicants/model/EvaluationPresentationModel";

export default class ShowFormVersionEvaluationsInteractor {
  private application: Application;
  private output?: IFormVersionEvaluationsPresenter;
  private evaluationService: IEvaluationService;
  private notificationService: INotificationService;

  constructor(application, evaluationService, notificationService) {
    this.application = application;
    this.evaluationService = evaluationService;
    this.notificationService = notificationService;
  }

  async getEvaluations(formVersionId: number) {
    try {
      return this.evaluationService.getFormEvaluations(formVersionId);
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute(formVersionId: number) {
    this.output = FormVersionEvaluationsPresenter({
      application: this.application,
      initialState: {
        evaluations: [] as TEvaluationPresentationModel[],
        confirmEvaluationModalVisible: false,
        formVersionId
      }
    });

    this.getEvaluations(formVersionId).then(
      (evaluations) =>
        this.output && this.output.setInitialData(formVersionId, evaluations)
    );

    return this.output;
  }
}
